import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Tabs, notification } from 'antd';

import ConsignmentImportPreloading from '@src/components/logistics/import/consignments/consignment-import-preloading';

import FormHeader from '@controls/form-header/form-header';

import { exception } from '@extensions/notification';
import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { IInboundCarrier } from '@src/entities/inbound-carrier';

import { ICity } from '@entities/city';
import { ICountry } from '@entities/country';

import { serverFetch } from '@src/server';

const ConsignmentPreloading = () => {
    const { carrierId } = useParams();

    const d = useAppDispatch();

    const [api, contextHolder] = notification.useNotification();

    const [countries, setCountries] = useState<Array<ICountry>>([]);
    const [cities, setCities] = useState<Array<ICity>>([]);
    const [carrier, setCarrier] = useState<IInboundCarrier>();

    useEffect(() => {
        let cleanup = false;

        const fetchData = async () => {
            const promises = [
                await serverFetch(`inboundcarriers/${carrierId}`, { method: 'GET' })
                    .then((data) => {
                        return data;
                    })
                    .catch((ex) => {
                        exception(api, 'Ошибка получения рейса', ex, () => d(userLoaded(undefined)));
                    }),
                await serverFetch(`countries`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения стран', ex, () => d(userLoaded(undefined)));
                    }),
                await serverFetch(`cities`, { method: 'GET' })
                    .then((data: any) => {
                        return data;
                    })
                    .catch((ex: any) => {
                        exception(api, 'Ошибка получения городов', ex, () => d(userLoaded(undefined)));
                    }),
            ];

            Promise.all([promises]).then((result) => {
                if (cleanup) return;

                const serverCarrier: IInboundCarrier = result[0][0];
                setCarrier(serverCarrier);

                let serverCountries: Array<ICountry> = result[0][1];
                serverCountries = serverCountries.filter((c) => c.airportCode == serverCarrier.departurePoint);

                setCountries(serverCountries);

                setCities(result[0][2]);
            });
        };

        fetchData();
        return () => {
            cleanup = true;
        };
    }, []);

    const tabItems = [
        {
            label: `Импорт`,
            key: 'import',
            children: (
                <ConsignmentImportPreloading
                    carrier={carrier}
                    cities={cities}
                    countryIds={countries.map((c) => {
                        return c.id || '';
                    })}
                    api={api}
                    serverFetch={serverFetch}
                />
            ),
        },
    ];

    return (
        <>
            <FormHeader title={`Добавить из предзагрузки в (${carrier?.number})`} />
            <Tabs size='small' items={tabItems} style={{ marginTop: -10 }}></Tabs>
            {contextHolder}
        </>
    );
};

export default ConsignmentPreloading;
